import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../../components/funcionales/titder';

//Tipos de recursos
const DetalleNivel1 = ({elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.descrTipoOS}</td>
      <td className=''>{elemento.descrCategOST}</td>
      <td className=''>{elemento.observCategOST}</td>
    </tr>
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} 
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const ConfCaOST2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a252301 = autorizacUA.findIndex( autorizac => autorizac === "252301" );

  return (
    <div>
      <List selection>
        <TitDer list={list} textBoton1="Categorías Tipos OS" btnNuevo={a252301!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />
        <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '30%'}}>Tipo OS</th>
                <th className='' style={{width: '30%'}}>Descripción</th>
                <th className='' style={{width: '40%'}}>Observaciones</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>
      </List>
    </div>
  )
};

export default ConfCaOST2
